/**
 * WebGL Context Optimization - Performance Enhancement
 * Prevents WebGL context loss errors that cause browser performance degradation
 */

let webglContextLossCount = 0;
const MAX_CONTEXT_LOSSES = 3;

export function initializeWebGLOptimization() {
  // Add global WebGL context loss prevention
  window.addEventListener('webglcontextlost', function(e) {
    webglContextLossCount++;
    console.warn('WebGL context lost:', webglContextLossCount);
    
    if (webglContextLossCount >= MAX_CONTEXT_LOSSES) {
      // Disable WebGL rendering to prevent further issues
      console.log('Disabling WebGL after repeated context losses');
      e.preventDefault();
      return false;
    }
    
    e.preventDefault(); // Prevent default context loss behavior
  }, false);
  
  window.addEventListener('webglcontextrestored', function(e) {
    console.log('WebGL context restored');
  }, false);
  
  // Optimize WebGL memory management
  if (window.WebGLRenderingContext) {
    const originalDeleteBuffer = WebGLRenderingContext.prototype.deleteBuffer;
    WebGLRenderingContext.prototype.deleteBuffer = function(buffer) {
      try {
        if (buffer && this.isBuffer && this.isBuffer(buffer)) {
          return originalDeleteBuffer.call(this, buffer);
        }
      } catch (e) {
        // Silently handle context mismatch errors
      }
    };
  }
}

// Auto-initialize on import
if (typeof window !== 'undefined') {
  initializeWebGLOptimization();
}